import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';

interface DarkModeToggleProps {
  className?: string;
}

const DarkModeToggle: React.FC<DarkModeToggleProps> = ({ className }) => {
  // Check if user has dark mode preference or has previously set it
  const [isDarkMode, setIsDarkMode] = useState<boolean>(() => {
    const savedMode = localStorage.getItem('darkMode');
    // Check user's system preference if no saved preference
    if (savedMode === null) {
      return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
    return savedMode === 'true';
  });

  // Apply dark mode whenever the state changes
  useEffect(() => {
    const root = document.documentElement;
    
    if (isDarkMode) {
      root.classList.add('dark-mode');
      document.body.classList.add('dark-mode');
    } else {
      root.classList.remove('dark-mode');
      document.body.classList.remove('dark-mode');
    }
    
    // Save preference to localStorage
    localStorage.setItem('darkMode', String(isDarkMode));
  }, [isDarkMode]);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <div className={`dark-mode-toggle ${className || ''}`}>
      <Button 
        icon={isDarkMode ? 'pi pi-moon' : 'pi pi-sun'}
        onClick={toggleDarkMode}
        className="p-button-rounded p-button-text dark-mode-button"
        style={{ 
          transition: 'all 0.3s ease',
          background: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
          color: isDarkMode ? 'white' : 'black',
          border: 'none',
        }}
        aria-label="Toggle dark mode"
      />
    </div>
  );
};

export default DarkModeToggle;
